var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;
  for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : sParameterName[1];
      }
  }
};

var onFooterCaptchaSuccess = function() {
var $form = $('#footerSubscribe'),
     source = getUrlParameter('utm_source'),
     email = $form.find('.mailing-list-email').val();

Sailthru.integration("userSignUp", 
  { 
  "email" : email,
  "lists" : {
    "*MASTER LIST" : 1,
    "DAILY (Main)": 1
  },
  "keys": {
   
  },
  "vars": {
      "source": source,
      "pageUrl": window.location.pathname
  },
  "optout_email": "none",  
  "fields": {
    "optout_email": "none",
  },
  "id": email,
  "key": "email", 
  "source" : source,
  "onSuccess" : function() {
    $('.js-grecaptcha-footer').removeClass('is-active');
    $form.find('.js-sailthru-footer-container').addClass('is-hidden');
    $form.find('.js-sailthru-footer-success').removeClass('is-hidden');
    localStorage.setItem('em', email);
   },
  "onError" : function(response) {
    $form.removeClass('is-loading');
    $form.find('.js-sailthru-footer-error').html(footerSubmitErrorMsg + ' (' + response.error + ')' ).removeClass('hidden');
   }
});

gtag("event", "Subscribe", {
  "Page": window.location.href.split('?')[0]
});
}

var initFooterSubscribe = function() {
 var footerSubmitErrorMsg = "There is a problem with the form, please check and correct errors.";
 $('#footerSubscribe').on('submit', function(e){
   e.preventDefault();
   var $form = $(this),
       source = getUrlParameter('utm_source'),
       email = $form.find('.mailing-list-email').val();
   
   $('.js-sailthru-footer-container').addClass('is-hidden');
   $('.js-grecaptcha-footer').addClass('is-active');
   
   
 })
}

var initDynamicCarousel = function() {
var width = $(window).width();

if (width < 1000) {
  $('.js-carousel-flickity').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    prevNextButtons: false
  });
}
}

var initStaticCarousel = function() {
$('.js-carousel-static').each(function(){
  var $carousel = $(this),
      width = $(window).width(),
      blocksAmount = parseInt($carousel.data('blocks-count'));

  if (width < 1000 || blocksAmount > 3 ) {
    $carousel.flickity({
      // options
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false
    });
  }
})
}

var initDynamicImage = function() {
$('.js-jobboard-section').each(function(){
  var $this = $(this),
      $width = $(window).outerWidth(),
      backgroundHeight = $this.data('height'),
      backgroundWidth = $this.data('width');

  if (backgroundHeight && backgroundWidth) {
    var imageRatio = parseInt(backgroundHeight) / parseInt(backgroundWidth),
        containerWidth = $this.outerWidth(),
        newHeight =  containerWidth * imageRatio;

    $this.css('min-height', newHeight);
  }
})
}

var initTrackingEvents = function() {
$('.js-track-events').on('click touchend',function(){
  var $this = $(this),
      category = $this.data('event-category'),
      action = $this.data('event-action'),
      label = $this.data('event-label') || '';

  if (window.gtag) {
      gtag('event', action, {
          'Page': label
      });
  }
})
}

var initArticleBanners = function() {
var isArticle = $('body').hasClass('template-article');

if (isArticle) {
  var $article = $('.blog-post-inner'),
      $bannerOrigin = $('#customBanner'),
      bannerOriginLink = $bannerOrigin.find('.js-content-banner-link').attr('href'),
      bannerOriginDesktop = $bannerOrigin.find('.js-content-banner-desktop').attr('src'),
      bannerOriginMobile = $bannerOrigin.find('.js-content-banner-mobile').attr('src');

  $article.find('img').each(function(){
    var $this = $(this),
        imgAlt = $this.attr('alt').toLowerCase().replaceAll(' ', '');

    if (imgAlt == "girlbossdailybanner" && $bannerOrigin.length > 0) {
      $this.addClass('sh-content-banner sh-content-banner-desktop');
      $this.attr('src', bannerOriginDesktop);
      $this.wrap("<div class='sh-content-banners'><a class='js-dynamic-content-banner' href='" + bannerOriginLink + "'></a></div>");
      $this.parent().append("<img class='sh-content-banner sh-content-banner-mobile' src='" + bannerOriginMobile + "'></>")
    }
  })
}
}

var initWebTicker = function() {
$('.js-web-ticker').each(function(){
  var $this = $(this),
      speed = $this.data('speed') || 50;
  
  $(this).webTicker({
    speed: speed,
    duplicate: true,
    hoverpause: false,
    startEmpty: false,
    height: '50px'
  });
});
}

var initHomepageCarousel = function() {
$('.js-blog-carousel').each(function(){
  var $carousel = $(this),
      width = $(window).width(),
      blocksAmount = parseInt($carousel.data('blocks-count'));

  $carousel.flickity('destroy')
  
  // if (width < 1000 || blocksAmount > 3 ) {
    $carousel.flickity({
      // options
      cellAlign: 'left',
      contain: true,
      resize: true,
      imagesLoaded: true,
      prevNextButtons: true
    });
  // }
})

$('.js-blog-carousel-mobile').each(function(){
  var $carousel = $(this),
      width = $(window).width(),
      blocksAmount = parseInt($carousel.data('blocks-count'));

  $carousel.flickity('destroy')
  
  if (width < 799 || blocksAmount > 3 ) {
    $carousel.flickity({
      // options
      cellAlign: 'left',
      contain: true,
      prevNextButtons: true
    });
  }
})


}

var initHomepageBannerCarousel = function(el) {
  var $carousel = el,
      width = $(window).width(),
      blocksAmount = parseInt($carousel.data('blocks-count'));
  
  $carousel.flickity('destroy');
 
  setTimeout(function () {
    $carousel.flickity({
      // options
      cellAlign: 'left',
      contain: true,
      resize: true,
      imagesLoaded: true,
      prevNextButtons: true
    });
  }, 100);

  
}

var initHomepageCarouselEvents = function() {
$('.js-navigation-menu-link').on('click', function(){
  var href = $(this).data('href'),
      $carousel = $(this).parents('.home-blog-carousel').find('.js-blog-carousel'),
      articles = $('#homeBlogArticles').find('div[data-group="' + href + '"]').html();
  $carousel.find('.flickity-slider').html(articles);

  $carousel.find('.flickity-slider').find('.home-blog-post-image').each(function(){
    var $img = $(this).find('img'),
        src = $img.attr('src');

    $img.attr('srcset', src);
  })
  
  $(this).parents('.navigation-menu').find('li').children().removeClass('link--active');
  $(this).addClass('link--active');
  initHomepageBannerCarousel($(this).parents('.home-blog-carousel').find('.js-blog-carousel'));
})
}

var initRadioCarousel = function() {
$('.js-radio-episodes').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    prevNextButtons: true
  });
}

var initTeamCarousel = function() {
$('.js-carousel-featureslist').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    prevNextButtons: true,
    pageDots: false
  });
}

var initQuotesCarousel = function() {
var minHeight = 0;

var intrvl = setInterval(function(){
    var $current = $('.js-quotes-carousel-item.is-active'),
        currentHeight = $('.quotes-carousel-items').outerHeight(),
        $next = $current.next();
  
    if (minHeight < currentHeight) {
      minHeight = currentHeight;
      $('.quotes-carousel-items').css('min-height', minHeight)
    }

    if ($next.length == 0) {
      var $current2 = $('.js-quotes-carousel-item').last(),
          $next2 = $('.js-quotes-carousel-item').first();

      $current2.fadeOut( "slow", function() {
        $current2.removeClass('is-active');
        $next2.fadeIn().addClass('is-active');
      });
      
    } else {
      $current.fadeOut( "slow", function() {
        $current.removeClass('is-active');
        $next.fadeIn().addClass('is-active');
      });
    }
    
},5000);
}

var initFoundersCarousel = function() {
var width = $(window).width();

if (width < 800) {
  $('.js-founders-carousel').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    prevNextButtons: true,
    pageDots: false
  });
}
}

var initTestimonialsCarousel = function() {
$('.js-testimonials-carousel').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    prevNextButtons: true,
    pageDots: false
  });
}

var initFaqEvents = function() {
$('.js-faq-item-toggle').on('click', function(){
  $(this).parent().toggleClass('is-expanded');
})
}

var initArticlesScroll = function() {
// Check if user came from pagination
const urlParams = new URLSearchParams(window.location.search);
const scrollToValue = urlParams.get('scrollTo');

if (scrollToValue && scrollToValue.trim() !== '') {
  // Use the scrollTo parameter value as the element ID
  const targetElement = document.getElementById(scrollToValue);
  
  if (targetElement) {
    targetElement.scrollIntoView();
  } else {
    console.warn(`Element with ID "${scrollToValue}" not found`);
  }
}
}

var normalizeTimeString = function(time) {
if (!time) {
  return time;
}

var segments = time.split(':');

if (segments.length < 2) {
  return time;
}

var lastTwoSegments = segments.slice(-2);

if (lastTwoSegments[0].length === 1) {
  lastTwoSegments[0] = ('0' + lastTwoSegments[0]).slice(-2);
}

return lastTwoSegments.join(':');
}

var initTimelineEvents = function() {
$('.js-timeline-wrapper').find('li').each(function(){
var $this = $(this),
    contentSplitted = $this.text().split(' '),
    timeStamp = contentSplitted[0],
    timestampCopy = contentSplitted[1],
    timeStampNode = $this.text().split(timeStamp)[1],
    newTimeStamp = "<span class='timeline-item js-timeline-item' data-time='" + timeStamp + "'>" + timeStamp + "</span>",
    newTimeStampNode = newTimeStamp + " " + timeStampNode;
    $this.html(newTimeStampNode);
    $this.attr('data-time', timeStamp);
})

// Make the whole js-timeline-wrapper clickable
$('.js-timeline-wrapper li').on('click', function(){
  var $transcript = $('#transcript'),
   time = $(this).attr('data-time'),
   $target = $transcript.find(".js-transcript-timestamp-anchor[data-time='" + time + "']").first();

   if (!$target.length) {
     return;
   }

   // First click on js-transcript-toggle to make transcript active and visible
   var $transcriptContent = $transcript.find('.js-transcript-content');
   if ($transcriptContent.length && !$transcriptContent.is(':visible')) {
     $transcript.find('.js-transcript-toggle').click();
   }

   // Toggle Content
   $('.js-transcript-category-copy').removeClass('is-active');
   $target.next().addClass('is-active');

   // Recalculate scroll position after DOM updates
   var scrollToTarget = function() {
     // Use requestAnimationFrame to ensure layout has recalculated
     requestAnimationFrame(function() {
       requestAnimationFrame(function() {
         var targetOffset = $target.offset().top;
         var scrollOffset = targetOffset - 20; // Optional offset for spacing

         $('html, body').animate({
           scrollTop: scrollOffset
         }, 400);
       });
     });
   };

   // Small delay to allow class changes to take effect and transcript to expand
   setTimeout(scrollToTarget, $transcriptContent.is(':visible') ? 50 : 100);
})
}

var initTranscriptEvents = function() {
var $transcript = $('#transcript');

if (!$transcript.length) {
  return;
}

var transcriptHtml = $transcript.html();
var updatedTranscriptHtml = transcriptHtml.replace(/\[(\d{2}:\d{2}:\d{2})\]/g, function(_, time) {
  var normalizedTime = normalizeTimeString(time);
  return "<h3 class='js-transcript-timestamp-anchor transcript-timestamp-anchor' data-time='" + normalizedTime + "'>" + normalizedTime + "</h3>";
});

if (transcriptHtml !== updatedTranscriptHtml) {
  $transcript.html(updatedTranscriptHtml);
}

$('.js-transcript-timestamp-anchor').on('click', function(){
  var isExpanded = $(this).next().hasClass('is-active');

  $('.js-transcript-category-copy').removeClass('is-active');
  $('.js-transcript-timestamp-anchor').removeClass('is-expanded');

  if (isExpanded) {

  } else {
      $(this).addClass('is-expanded');
      $(this).next().addClass('is-active');
  }
  
})
}

var initTranscriptParts = function() {
var $transcript = $('#transcript');

if (!$transcript.length) {
  return;
}

// Create collapsible wrapper structure
var transcriptContent = $transcript.html();
var collapsibleWrapper = '<div class="transcript-collapsible">' +
                        '<h3 class="transcript-toggle js-transcript-toggle">Full Transcript</h3>' +
                        '<div class="transcript-content js-transcript-content" style="display: none;">' +
                        transcriptContent +
                        '</div>' +
                        '</div>';

$transcript.html(collapsibleWrapper);

// Add click event for toggle
$transcript.on('click', '.js-transcript-toggle', function(){
  var $content = $(this).siblings('.js-transcript-content');
  
  if ($content.is(':visible')) {
    $content.hide();
  } else {
    $content.show();
  }
});

  // Update the transcript parts
  // $('.js-transcript-timestamp-anchor').each(function(){
  //   var $this = $(this),
  //       time = $this.attr('data-time'),
  //       timelineItem = $('.js-timeline-item[data-time="' + time + '"]').parent().text().split(' '),
  //       timelineCategory = timelineItem.join(' ');
        
  //     $this.html(timelineCategory);
  // })
}

var removeUnusedTimestamps = function() {
$('.js-transcript-timestamp-anchor').each(function(){
  var $this = $(this),
      copy = $this.text();

      if (copy == "") {
        $this.remove();
      }
})
}

var wrapTranscriptCopy = function() {
var $transcript = $('#transcript');

if (!$transcript.length) {
  return;
}

var anchors = $transcript.find('.js-transcript-timestamp-anchor');

if (!anchors.length) {
  return;
}

anchors.each(function(index){
  var currentAnchor = this;
  var nextAnchor = anchors.get(index + 1) || null;
  var nodesToWrap = [];
  var node = currentAnchor.nextSibling;

  while (node && node !== nextAnchor) {
    var nextNode = node.nextSibling;

    if (node.nodeType === 3) {
      var textContent = node.nodeValue;

      if (!textContent || !textContent.trim()) {
        currentAnchor.parentNode.removeChild(node);
        node = nextNode;
        continue;
      }

      var textWrapper = document.createElement('p');
      textWrapper.textContent = textContent.trim();
      currentAnchor.parentNode.insertBefore(textWrapper, node);
      currentAnchor.parentNode.removeChild(node);
      node = textWrapper;
    }

    nodesToWrap.push(node);
    node = nextNode;
  }

  if (!nodesToWrap.length) {
    return;
  }

  var wrapper = document.createElement('div');
  wrapper.className = 'js-transcript-category-copy transcript-category-copy';

  var firstNode = nodesToWrap[0];
  firstNode.parentNode.insertBefore(wrapper, firstNode);

  nodesToWrap.forEach(function(contentNode){
    wrapper.appendChild(contentNode);
  });
});
}


var makeSidebarAdsSticky = function(wrapper) {
  if (!wrapper || wrapper.getAttribute('data-sticky-applied')) {
    return;
  }

  // Mark immediately so MutationObserver doesn't re-init while we wait for iframes
  wrapper.setAttribute('data-sticky-applied', 'true');

  var topOffset = 70,
      bottomOffset = 400, // start releasing before .main-footer (px)
      gap = 12,
      iframe1 = null,
      iframe2 = null,
      isFixed = false,
      started = false,
      startY = 0,
      left1 = 0,
      width1 = 0,
      left2 = 0,
      width2 = 0;

  var getIframe = function(adId) {
    var ad = document.getElementById(adId);
    return ad ? ad.querySelector('iframe') : null;
  };

  var refreshIframes = function() {
    iframe1 = getIframe('ad-m32-girlboss-1');
    iframe2 = getIframe('ad-m32-girlboss-2');
  };

  var clearFixedStyles = function(el) {
    if (!el) {
      return;
    }

    el.style.position = '';
    el.style.top = '';
    el.style.left = '';
    el.style.width = '';
    el.style.zIndex = '';
  };

  var getStackHeight = function() {
    var height = iframe1.offsetHeight;

    if (iframe2 && iframe2.offsetHeight > 0) {
      height += gap + iframe2.offsetHeight;
    }

    return height;
  };

  var cacheMetrics = function() {
    var rect1 = iframe1.getBoundingClientRect(),
        scrollY = window.pageYOffset || document.documentElement.scrollTop;

    startY = rect1.top + scrollY;
    left1 = rect1.left;
    width1 = rect1.width;

    if (iframe2 && iframe2.offsetHeight > 0) {
      var rect2 = iframe2.getBoundingClientRect();
      left2 = rect2.left;
      width2 = rect2.width;
    }
  };

  var unpin = function() {
    clearFixedStyles(iframe1);
    clearFixedStyles(iframe2);
    wrapper.style.minHeight = '';
    isFixed = false;
  };

  var pinAt = function(top1) {
    var totalHeight = getStackHeight();

    iframe1.style.position = 'fixed';
    iframe1.style.top = top1 + 'px';
    iframe1.style.left = left1 + 'px';
    iframe1.style.width = width1 + 'px';
    iframe1.style.zIndex = '100';

    if (iframe2 && iframe2.offsetHeight > 0) {
      iframe2.style.position = 'fixed';
      iframe2.style.top = (top1 + iframe1.offsetHeight + gap) + 'px';
      iframe2.style.left = left2 + 'px';
      iframe2.style.width = width2 + 'px';
      iframe2.style.zIndex = '100';
    }

    wrapper.style.minHeight = totalHeight + 'px';
    isFixed = true;
  };

  var onScroll = function() {
    refreshIframes();

    if (!iframe1 || !iframe1.offsetHeight) {
      return;
    }

    var scrollY = window.pageYOffset || document.documentElement.scrollTop,
        totalHeight = getStackHeight(),
        footer = document.querySelector('.main-footer'),
        footerTop = footer ? footer.getBoundingClientRect().top : Infinity;

    // Still above natural position — keep in document flow
    if (!isFixed) {
      cacheMetrics();

      if (iframe1.getBoundingClientRect().top > topOffset) {
        return;
      }
    } else if (scrollY + topOffset < startY) {
      unpin();
      return;
    }

    // Default sticky top; push up before footer reaches the ad stack
    var top1 = topOffset;

    if (footerTop < topOffset + totalHeight + bottomOffset) {
      top1 = footerTop - totalHeight - bottomOffset;
    }

    // Cache left/width once when entering sticky (before fixed skews them)
    if (!isFixed) {
      cacheMetrics();
    }

    pinAt(top1);
  };

  var onResize = function() {
    if (isFixed) {
      unpin();
    }
    onScroll();
  };

  var startListening = function() {
    if (started) {
      return;
    }

    started = true;
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
  };

  // Ads/iframes inject asynchronously — start once the first iframe has size
  var readyCheck = setInterval(function() {
    refreshIframes();

    if (iframe1 && iframe1.offsetHeight > 0 && iframe1.offsetWidth > 0) {
      clearInterval(readyCheck);
      startListening();
    }
  }, 200);
}

var initStickyAd = function() {
  var findWrapper = function() {
    return document.getElementById('sidebarAdsWrapper') || null;
  };

  var wrapper = findWrapper();

  if (wrapper) {
    makeSidebarAdsSticky(wrapper);
    return;
  }

  var observer = new MutationObserver(function() {
    var foundWrapper = findWrapper();

    if (foundWrapper) {
      makeSidebarAdsSticky(foundWrapper);
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}


$(document).ready(function(){
initFooterSubscribe();
initDynamicCarousel();
initStaticCarousel();
initDynamicImage();
initTrackingEvents();
initArticleBanners();
initWebTicker();
initHomepageCarousel();
initHomepageCarouselEvents();
initQuotesCarousel();
initTeamCarousel();
initFoundersCarousel();
initFaqEvents();
initTestimonialsCarousel(); 
initArticlesScroll();
initTimelineEvents();
initTranscriptEvents();
initTranscriptParts();
// removeUnusedTimestamps();
wrapTranscriptCopy();
initStickyAd();
})